import { Fragment } from 'react'
import {
  StyleFileWrapper,
  StyleFilesWrapper,
  StyleImage,
  StyleImageWrapper,
  StyleRemoveFile,
} from './style'
import { Constant } from '@utils'
import Svg from '@components/svg'
import Typography from '@components/typography'
const Files = ({ files, onRemoveFile }: any) => {
  return (
    <StyleFilesWrapper
      onClick={(event) => {
        const target = event.target as HTMLElement
        const cross = target.closest('[data-cross-id]')
        if (!!cross) {
          const attribute = cross.getAttribute('data-cross-id')
          const splitAttribute = attribute.split('-')
          onRemoveFile(splitAttribute[0])
        }
      }}
    >
      {files?.map((file: any, index) => {
        return (
          <Fragment key={index}>
            {Constant.imageValidationExtensions.includes(file?.extension) ? (
              <StyleImageWrapper>
                <StyleImage src={`${file?.info},${file?.base64}`} />
                <StyleRemoveFile data-cross-id={index}>
                  <Svg svg="crossIcon" color={'white'} size={12} />
                </StyleRemoveFile>
              </StyleImageWrapper>
            ) : (
              <StyleFileWrapper>
                <Svg svg="document" color="black" />
                <Typography
                  content={file?.fileName}
                  size={12}
                  styleText="
                    word-break:break-all;
                "
                />
                <StyleRemoveFile data-cross-id={index}>
                  <Svg svg="crossIcon" color={'white'} size={12} />
                </StyleRemoveFile>
              </StyleFileWrapper>
            )}
          </Fragment>
        )
      })}
    </StyleFilesWrapper>
  )
}
export default Files
